import { PAYMENT_TYPE } from './constants.js';
import { processingFee } from './processingFee.js';
export const FUNDRAISER_FEE_RULE_NAME = 'fundraiser_fee';
const round2 = (value) => Math.round((Number(value) || 0) * 100) / 100;
export const normalizeOrganizationFeeRules = (organizationFeeConfig) => {
    if (Array.isArray(organizationFeeConfig)) {
        return organizationFeeConfig;
    }
    const config = organizationFeeConfig;
    const raw = config?.rules ||
        config?.attributes
            ?.rules ||
        config?.data?.rules ||
        [];
    return Array.isArray(raw) ? raw : [];
};
export const findFundraiserFeeRule = (rules) => {
    if (!Array.isArray(rules))
        return null;
    return (rules.find((rule) => String(rule?.name || '')
        .trim()
        .toLowerCase() === FUNDRAISER_FEE_RULE_NAME) || null);
};
const readFundraiserFeeRuleValue = (rule) => {
    const value = Number(rule?.value ?? rule?.fee);
    return Number.isFinite(value) && value > 0 ? value : null;
};
export const calculateFundraiserPlatformFee = (donationAmount, rule) => {
    const base = Number(donationAmount);
    if (!rule || !Number.isFinite(base) || base <= 0)
        return 0;
    const value = readFundraiserFeeRuleValue(rule);
    if (value === null)
        return 0;
    const method = String(rule.method || '').toLowerCase();
    if (method === 'percentage') {
        return round2((base * value) / 100);
    }
    if (method === 'fixed') {
        return round2(value);
    }
    if (value <= 1) {
        return round2(base * value);
    }
    return round2((base * value) / 100);
};
export const resolveProcessingFeeBase = (donationAmount, platformFee) => round2((Number(donationAmount) || 0) + (Number(platformFee) || 0));
export const defaultCardProcessingFee = (paymentMethod, amount) => {
    if (paymentMethod !== PAYMENT_TYPE.CARD && paymentMethod !== 'card') {
        return 0;
    }
    return processingFee({
        amount,
        ratePercentage: 0.029,
        rateAmount: 0.3,
        salesChannel: 'online',
        paymentOption: 'online',
        paymentMethod: 'card',
    });
};
export const resolveFundraisingDonationPricing = ({ donationAmount, paymentMethod = PAYMENT_TYPE.CARD, organizationFeeRules = [], getProcessingFee = defaultCardProcessingFee, }) => {
    const donation = round2(donationAmount);
    if (!Number.isFinite(donation) || donation <= 0) {
        return {
            donationAmount: 0,
            platformFee: 0,
            processingFee: 0,
            totalCharge: 0,
        };
    }
    const rule = findFundraiserFeeRule(organizationFeeRules);
    const platformFee = calculateFundraiserPlatformFee(donation, rule);
    const processingBase = resolveProcessingFeeBase(donation, platformFee);
    const resolvedProcessingFee = round2(getProcessingFee(paymentMethod, processingBase) || 0);
    const totalCharge = round2(donation + platformFee + resolvedProcessingFee);
    return {
        donationAmount: donation,
        platformFee,
        processingFee: resolvedProcessingFee,
        totalCharge,
    };
};
export const EMPTY_FUNDRAISING_DONATION_PRICING = {
    donationAmount: 0,
    platformFee: 0,
    processingFee: 0,
    totalCharge: 0,
};
